// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.display-board {
  min-height: 100vh;
  padding: 2rem;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  position: relative;
}
.display-board::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 20% 50%, rgba(120, 119, 198, 0.05) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.05) 0%, transparent 50%), radial-gradient(circle at 40% 80%, rgba(120, 219, 226, 0.05) 0%, transparent 50%);
  z-index: -1;
}
.display-board .dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  animation: fadeInDown 0.8s ease-out;
}
.display-board .dashboard-header .main-dashboard-header {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.display-board .dashboard-header .display-board-expbtn {
  width: 100%;
  display: flex;
  justify-content: end;
}
.display-board .dashboard-header .display-board-expbtn .export-btn {
  cursor: pointer;
  padding: 8px 18px;
  background-color: var(--primary-color);
  color: #fff;
  border: 1px solid var(--primary-color);
  border-radius: 0.5rem;
}
.display-board .dashboard-header h1 {
  font-size: 2rem;
  font-weight: 800;
  background-color: var(--primary-color);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 0.5rem;
  letter-spacing: -0.025em;
}
.display-board .dashboard-header p {
  color: #64748b;
  font-size: 1.1rem;
  font-weight: 500;
  opacity: 0.8;
}
.display-board .member-selection {
  margin-top: 1rem;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: fit-content;
}
.display-board .member-selection label {
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  margin: 0;
  white-space: nowrap;
}
.display-board .member-selection .member-dropdown {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: auto;
  min-width: 200px;
  max-width: 280px;
  padding: 8px 12px;
  padding-right: 36px;
  font-size: 0.9rem;
  font-weight: 500;
  color: #374151;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 8px center;
  background-repeat: no-repeat;
  background-size: 14px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  outline: none;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
.display-board .member-selection .member-dropdown:hover {
  border-color: #d1d5db;
}
.display-board .member-selection .member-dropdown:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1), 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transform: translateY(-1px);
}
.display-board .member-selection .member-dropdown:active {
  transform: translateY(0);
}
.display-board .member-selection .member-dropdown:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.display-board .member-selection .member-dropdown:disabled:hover {
  transform: none;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
.display-board .member-selection .member-dropdown option {
  padding: 12px 16px;
  font-weight: 500;
  color: #374151;
  background-color: #fff;
}
.display-board .member-selection .member-dropdown option:hover {
  background-color: #f3f4f6;
}
.display-board .member-selection .member-dropdown option:checked {
  background-color: var(--primary-color);
  color: #fff;
}
.display-board .member-selection .member-dropdown option[value=""] {
  color: #9ca3af;
  font-style: italic;
}
.display-board .member-selection.loading {
  position: relative;
}
.display-board .member-selection.loading .member-dropdown {
  opacity: 0.6;
  cursor: not-allowed;
}
.display-board .member-selection.loading .member-dropdown::after {
  content: "";
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 14px;
  height: 14px;
  border: 2px solid #e5e7eb;
  border-top: 2px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.display-board .member-selection.error .member-dropdown {
  border-color: #ef4444;
}
.display-board .member-selection.error .member-dropdown:focus {
  border-color: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1), 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
.display-board .loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  color: #64748b;
}
.display-board .loading-container .loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}
.display-board .loading-container p {
  font-size: 1.1rem;
  font-weight: 500;
}
.display-board .widgets-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-auto-rows: auto;
  gap: 2rem;
}
.display-board .widgets-grid .widget {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  padding: 0;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  animation: fadeInUp 0.8s ease-out forwards;
  opacity: 0;
  transform: translateY(40px);
}
.display-board .widgets-grid .widget.calendar-widget {
  position: relative;
  z-index: 50; /* Forces Calendar & Tooltip to float ON TOP of everything */
}
.display-board .widgets-grid .widget.stats-widget {
  position: relative;
  z-index: 1; /* Keeps Stats lower so the tooltip can cover it */
}
.display-board .widgets-grid .widget:hover {
  transform: translateY(-12px) scale(1.02);
  background: rgba(255, 255, 255, 0.95);
}
.display-board .widgets-grid .widget:hover::before {
  opacity: 1;
}
.display-board .widgets-grid .widget:hover .widget-header h3 {
  transform: translateX(8px);
}
.display-board .widgets-grid .widget .widget-header {
  padding: 1rem;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, transparent 100%);
}
.display-board .widgets-grid .widget .widget-header h3 {
  font-size: 1.2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.25rem 0;
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.display-board .widgets-grid .widget .widget-header h3::before {
  content: "";
  width: 8px;
  height: 8px;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  border-radius: 50%;
  box-shadow: 0 0 12px rgba(59, 130, 246, 0.4);
}
.display-board .widgets-grid .widget .widget-header .widget-subtitle {
  color: #64748b;
  font-size: 0.9rem;
  font-weight: 500;
  opacity: 0.8;
}
.display-board .widgets-grid .widget.upcoming-widget {
  grid-column: 1/-1;
}
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (max-width: 1240px) {
  .display-board {
    padding: 1rem;
  }
  .display-board .dashboard-header h1 {
    font-size: 2rem;
  }
  .display-board .dashboard-header p {
    font-size: 1rem;
  }
  .display-board .member-selection {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    width: 100%;
  }
  .display-board .member-selection .member-dropdown {
    min-width: 100%;
    padding: 10px 12px;
    padding-right: 36px;
    font-size: 0.95rem;
  }
  .display-board .widgets-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .display-board .widgets-grid .upcoming-widget {
    grid-column: 1;
  }
  .display-board .widgets-grid .widget {
    border-radius: 16px;
  }
  .display-board .widgets-grid .widget:hover {
    transform: translateY(-6px);
  }
  .display-board .widgets-grid .widget .widget-header {
    padding: 1.5rem 1.5rem 1rem;
  }
  .display-board .widgets-grid .widget .widget-header h3 {
    font-size: 1.2rem;
  }
}
@media (max-width: 768px) {
  .display-board .member-selection {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    width: 100%;
  }
  .display-board .member-selection .member-dropdown {
    min-width: 100%;
    padding: 10px 12px;
    padding-right: 36px;
    font-size: 0.95rem;
  }
}
@media (max-width: 480px) {
  .display-board {
    padding: 0.75rem;
  }
  .display-board .dashboard-header h1 {
    font-size: 1.75rem;
  }
  .display-board .member-selection {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    width: 100%;
  }
  .display-board .member-selection label {
    font-size: 0.85rem;
  }
  .display-board .member-selection .member-dropdown {
    min-width: 100%;
    padding: 8px 10px;
    padding-right: 32px;
    font-size: 0.9rem;
  }
  .display-board .widgets-grid .widget {
    border-radius: 12px;
  }
  .display-board .widgets-grid .widget .widget-header {
    padding: 1.25rem 1.25rem 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/DisplayBoard/DisplayBoard.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,aAAA;EACA,6DAAA;EACA,kBAAA;AACF;AACE;EACE,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mQAAA;EAGA,WAAA;AADJ;AAIE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EAEA,mCAAA;AAHJ;AAKI;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AAHN;AAMI;EACE,WAAA;EACA,aAAA;EACA,oBAAA;AAJN;AAMM;EACE,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,WAAA;EACA,sCAAA;EACA,qBAAA;AAJR;AAQI;EACE,eAAA;EACA,gBAAA;EAEA,sCAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,wBAAA;AAPN;AAUI;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AARN;AAaE;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAXJ;AAaI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;AAXN;AAcI;EACE,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,yDAAA;EACA,qCAAA;EACA,4BAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,iDAAA;EACA,2EAAA;AAZN;AAcM;EACE,qBAAA;AAZR;AAiBM;EACE,kCAAA;EACA,oHACE;EAGF,2BAAA;AAlBR;AAqBM;EACE,wBAAA;AAnBR;AAsBM;EACE,YAAA;EACA,mBAAA;AApBR;AAsBQ;EACE,eAAA;EACA,2EAAA;AApBV;AAyBM;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AAvBR;AAyBQ;EACE,yBAAA;AAvBV;AA0BQ;EACE,sCAAA;EACA,WAAA;AAxBV;AA6BM;EACE,cAAA;EACA,kBAAA;AA3BR;AAgCI;EACE,kBAAA;AA9BN;AAgCM;EACE,YAAA;EACA,mBAAA;AA9BR;AAgCQ;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,0CAAA;EACA,kBAAA;EACA,kCAAA;AA9BV;AAoCI;EACE,qBAAA;AAlCN;AAoCM;EACE,qBAAA;EACA,mHACE;AAnCV;AA0CE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;AAxCJ;AA0CI;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;AAxCN;AA2CI;EACE,iBAAA;EACA,gBAAA;AAzCN;AA6CE;EACE,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,SAAA;AA3CJ;AA6CI;EAEE,oCAAA;EACA,2BAAA;EACA,0CAAA;EACA,mBAAA;EACA,UAAA;EACA,qFACE;EAEF,4DAAA;EACA,kBAAA;EAEA,0CAAA;EACA,UAAA;EACA,2BAAA;AA/CN;AAgDM;EACE,kBAAA;EACA,WAAA,EAAA,4DAAA;AA9CR;AAiDM;EACE,kBAAA;EACA,UAAA,EAAA,kDAAA;AA/CR;AAgEM;EACE,wCAAA;EAIA,qCAAA;AAjER;AAmEQ;EACE,UAAA;AAjEV;AAoEQ;EACE,0BAAA;AAlEV;AAsEM;EACE,aAAA;EAEA,kFAAA;AArER;AAuEQ;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AArEV;AAuEU;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,qDAAA;EACA,kBAAA;EACA,4CAAA;AArEZ;AAyEQ;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AAvEV;AA2EM;EACE,iBAAA;AAzER;AA8EE;EACE;IACE,UAAA;IACA,4BAAA;EA5EJ;EA+EE;IACE,UAAA;IACA,wBAAA;EA7EJ;AACF;AAgFE;EACE;IACE,UAAA;IACA,wBAAA;EA9EJ;AACF;AAiFE;EACE;IACE,uBAAA;EA/EJ;EAkFE;IACE,yBAAA;EAhFJ;AACF;AAmFE;EAjWF;IAkWI,aAAA;EAhFF;EAqFI;IACE,eAAA;EAnFN;EAsFI;IACE,eAAA;EApFN;EAwFE;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;IACA,WAAA;EAtFJ;EAwFI;IACE,eAAA;IACA,kBAAA;IACA,mBAAA;IACA,kBAAA;EAtFN;EA0FE;IACE,0BAAA;IACA,SAAA;EAxFJ;EA0FI;IACE,cAAA;EAxFN;EA2FI;IACE,mBAAA;EAzFN;EA2FM;IACE,2BAAA;EAzFR;EA4FM;IACE,2BAAA;EA1FR;EA4FQ;IACE,iBAAA;EA1FV;AACF;AAgGE;EACE;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;IACA,WAAA;EA9FJ;EAgGI;IACE,eAAA;IACA,kBAAA;IACA,mBAAA;IACA,kBAAA;EA9FN;AACF;AAkGE;EAxaF;IAyaI,gBAAA;EA/FF;EAiGE;IACE,kBAAA;EA/FJ;EAkGE;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;IACA,WAAA;EAhGJ;EAkGI;IACE,kBAAA;EAhGN;EAmGI;IACE,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,iBAAA;EAjGN;EAqGE;IACE,mBAAA;EAnGJ;EAqGI;IACE,gCAAA;EAnGN;AACF","sourcesContent":[".display-board {\r\n  min-height: 100vh;\r\n  padding: 2rem;\r\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\r\n  position: relative;\r\n\r\n  &::before {\r\n    content: '';\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: radial-gradient(circle at 20% 50%, rgba(120, 119, 198, 0.05) 0%, transparent 50%),\r\n      radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.05) 0%, transparent 50%),\r\n      radial-gradient(circle at 40% 80%, rgba(120, 219, 226, 0.05) 0%, transparent 50%);\r\n    z-index: -1;\r\n  }\r\n\r\n  .dashboard-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n    // margin-bottom: 1.5rem;\r\n    animation: fadeInDown 0.8s ease-out;\r\n\r\n    .main-dashboard-header {\r\n      width: 100%;\r\n      display: flex;\r\n      flex-direction: column;\r\n    }\r\n\r\n    .display-board-expbtn {\r\n      width: 100%;\r\n      display: flex;\r\n      justify-content: end;\r\n\r\n      .export-btn {\r\n        cursor: pointer;\r\n        padding: 8px 18px;\r\n        background-color: var(--primary-color);\r\n        color: #fff;\r\n        border: 1px solid var(--primary-color);\r\n        border-radius: 0.5rem;\r\n      }\r\n    }\r\n\r\n    h1 {\r\n      font-size: 2rem;\r\n      font-weight: 800;\r\n      // background: linear-gradient(135deg, #1e293b 0%, var(--primary-color) 50%, var(--primary-color) 100%);\r\n      background-color: var(--primary-color);\r\n      background-clip: text;\r\n      -webkit-background-clip: text;\r\n      -webkit-text-fill-color: transparent;\r\n      margin-bottom: 0.5rem;\r\n      letter-spacing: -0.025em;\r\n    }\r\n\r\n    p {\r\n      color: #64748b;\r\n      font-size: 1.1rem;\r\n      font-weight: 500;\r\n      opacity: 0.8;\r\n    }\r\n  }\r\n\r\n  // Member Selection Dropdown Styles\r\n  .member-selection {\r\n    margin-top: 1rem;\r\n    margin-bottom: 1rem;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.75rem;\r\n    width: fit-content;\r\n\r\n    label {\r\n      font-size: 1rem;\r\n      font-weight: 600;\r\n      color: #374151;\r\n      margin: 0;\r\n      white-space: nowrap;\r\n    }\r\n\r\n    .member-dropdown {\r\n      appearance: none;\r\n      -webkit-appearance: none;\r\n      -moz-appearance: none;\r\n      width: auto;\r\n      min-width: 200px;\r\n      max-width: 280px;\r\n      padding: 8px 12px;\r\n      padding-right: 36px;\r\n      font-size: 0.9rem;\r\n      font-weight: 500;\r\n      color: #374151;\r\n      background-color: #fff;\r\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\r\n      background-position: right 8px center;\r\n      background-repeat: no-repeat;\r\n      background-size: 14px;\r\n      border: 2px solid #e5e7eb;\r\n      border-radius: 8px;\r\n      outline: none;\r\n      cursor: pointer;\r\n      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\r\n\r\n      &:hover {\r\n        border-color: #d1d5db;\r\n        // box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\r\n        // transform: translateY(-1px);\r\n      }\r\n\r\n      &:focus {\r\n        border-color: var(--primary-color);\r\n        box-shadow: \r\n          0 0 0 3px rgba(59, 130, 246, 0.1),\r\n          0 4px 6px -1px rgba(0, 0, 0, 0.1),\r\n          0 2px 4px -1px rgba(0, 0, 0, 0.06);\r\n        transform: translateY(-1px);\r\n      }\r\n\r\n      &:active {\r\n        transform: translateY(0);\r\n      }\r\n\r\n      &:disabled {\r\n        opacity: 0.6;\r\n        cursor: not-allowed;\r\n        \r\n        &:hover {\r\n          transform: none;\r\n          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\r\n        }\r\n      }\r\n\r\n      // Custom option styling (limited browser support)\r\n      option {\r\n        padding: 12px 16px;\r\n        font-weight: 500;\r\n        color: #374151;\r\n        background-color: #fff;\r\n        \r\n        &:hover {\r\n          background-color: #f3f4f6;\r\n        }\r\n        \r\n        &:checked {\r\n          background-color: var(--primary-color);\r\n          color: #fff;\r\n        }\r\n      }\r\n\r\n      // Placeholder option styling\r\n      option[value=\"\"] {\r\n        color: #9ca3af;\r\n        font-style: italic;\r\n      }\r\n    }\r\n\r\n    // Loading state\r\n    &.loading {\r\n      position: relative;\r\n      \r\n      .member-dropdown {\r\n        opacity: 0.6;\r\n        cursor: not-allowed;\r\n        \r\n        &::after {\r\n          content: '';\r\n          position: absolute;\r\n          right: 8px;\r\n          top: 50%;\r\n          transform: translateY(-50%);\r\n          width: 14px;\r\n          height: 14px;\r\n          border: 2px solid #e5e7eb;\r\n          border-top: 2px solid var(--primary-color);\r\n          border-radius: 50%;\r\n          animation: spin 1s linear infinite;\r\n        }\r\n      }\r\n    }\r\n\r\n    // Error state\r\n    &.error .member-dropdown {\r\n      border-color: #ef4444;\r\n      \r\n      &:focus {\r\n        border-color: #ef4444;\r\n        box-shadow: \r\n          0 0 0 3px rgba(239, 68, 68, 0.1),\r\n          0 4px 6px -1px rgba(0, 0, 0, 0.1),\r\n          0 2px 4px -1px rgba(0, 0, 0, 0.06);\r\n      }\r\n    }\r\n  }\r\n\r\n  .loading-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-height: 50vh;\r\n    color: #64748b;\r\n\r\n    .loading-spinner {\r\n      width: 48px;\r\n      height: 48px;\r\n      border: 4px solid #e2e8f0;\r\n      border-top: 4px solid #3b82f6;\r\n      border-radius: 50%;\r\n      animation: spin 1s linear infinite;\r\n      margin-bottom: 1rem;\r\n    }\r\n\r\n    p {\r\n      font-size: 1.1rem;\r\n      font-weight: 500;\r\n    }\r\n  }\r\n\r\n  .widgets-grid {\r\n    display: grid;\r\n    grid-template-columns: 2fr 1fr;\r\n    grid-auto-rows: auto;\r\n    gap: 2rem;\r\n\r\n    .widget {\r\n      // z-index: 0;\r\n      background: rgba(255, 255, 255, 0.8);\r\n      backdrop-filter: blur(20px);\r\n      border: 1px solid rgba(255, 255, 255, 0.3);\r\n      border-radius: 12px;\r\n      padding: 0;\r\n      box-shadow:\r\n        0 20px 25px -5px rgba(0, 0, 0, 0.1),\r\n        0 10px 10px -5px rgba(0, 0, 0, 0.04);\r\n      transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n      position: relative;\r\n      // overflow: hidden;\r\n      animation: fadeInUp 0.8s ease-out forwards;\r\n      opacity: 0;\r\n      transform: translateY(40px);\r\n      &.calendar-widget {\r\n        position: relative;\r\n        z-index: 50; /* Forces Calendar & Tooltip to float ON TOP of everything */\r\n      }\r\n\r\n      &.stats-widget {\r\n        position: relative;\r\n        z-index: 1; /* Keeps Stats lower so the tooltip can cover it */\r\n      }\r\n\r\n      // &::before {\r\n      //   content: '';\r\n      //   position: absolute;\r\n      //   top: 0;\r\n      //   left: 0;\r\n      //   right: 0;\r\n      //   height: 4px;\r\n      //   background: linear-gradient(90deg, #3b82f6, #8b5cf6, #ec4899);\r\n      //   opacity: 0;\r\n      //   transition: opacity 0.3s ease;\r\n      //   z-index: 1;\r\n      //   border-radius: 24px 24px 0 0 !important;\r\n      // }\r\n\r\n      &:hover {\r\n        transform: translateY(-12px) scale(1.02);\r\n        // box-shadow:\r\n        //   0 32px 64px -12px rgba(0, 0, 0, 0.15),\r\n        //   0 20px 25px -5px rgba(0, 0, 0, 0.1);\r\n        background: rgba(255, 255, 255, 0.95);\r\n\r\n        &::before {\r\n          opacity: 1;\r\n        }\r\n\r\n        .widget-header h3 {\r\n          transform: translateX(8px);\r\n        }\r\n      }\r\n\r\n      .widget-header {\r\n        padding: 1rem;\r\n        // border-bottom: 1px solid rgba(0, 0, 0, 0.05);\r\n        background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, transparent 100%);\r\n\r\n        h3 {\r\n          font-size: 1.2rem;\r\n          font-weight: 700;\r\n          color: #1e293b;\r\n          margin: 0 0 0.25rem 0;\r\n          transition: transform 0.3s ease;\r\n          display: flex;\r\n          align-items: center;\r\n          gap: 0.75rem;\r\n\r\n          &::before {\r\n            content: '';\r\n            width: 8px;\r\n            height: 8px;\r\n            background: linear-gradient(135deg, #3b82f6, #8b5cf6);\r\n            border-radius: 50%;\r\n            box-shadow: 0 0 12px rgba(59, 130, 246, 0.4);\r\n          }\r\n        }\r\n\r\n        .widget-subtitle {\r\n          color: #64748b;\r\n          font-size: 0.9rem;\r\n          font-weight: 500;\r\n          opacity: 0.8;\r\n        }\r\n      }\r\n\r\n      &.upcoming-widget {\r\n        grid-column: 1 / -1;\r\n      }\r\n    }\r\n  }\r\n\r\n  @keyframes fadeInDown {\r\n    from {\r\n      opacity: 0;\r\n      transform: translateY(-30px);\r\n    }\r\n\r\n    to {\r\n      opacity: 1;\r\n      transform: translateY(0);\r\n    }\r\n  }\r\n\r\n  @keyframes fadeInUp {\r\n    to {\r\n      opacity: 1;\r\n      transform: translateY(0);\r\n    }\r\n  }\r\n\r\n  @keyframes spin {\r\n    0% {\r\n      transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n\r\n  @media (max-width: 1240px) {\r\n    padding: 1rem;\r\n\r\n    .dashboard-header {\r\n      // margin-bottom: 2rem;\r\n\r\n      h1 {\r\n        font-size: 2rem;\r\n      }\r\n\r\n      p {\r\n        font-size: 1rem;\r\n      }\r\n    }\r\n\r\n    .member-selection {\r\n      flex-direction: column;\r\n      align-items: flex-start;\r\n      gap: 0.5rem;\r\n      width: 100%;\r\n      \r\n      .member-dropdown {\r\n        min-width: 100%;\r\n        padding: 10px 12px;\r\n        padding-right: 36px;\r\n        font-size: 0.95rem;\r\n      }\r\n    }\r\n\r\n    .widgets-grid {\r\n      grid-template-columns: 1fr;\r\n      gap: 1rem;\r\n\r\n      .upcoming-widget {\r\n        grid-column: 1; // Reset to single column behavior\r\n      }\r\n\r\n      .widget {\r\n        border-radius: 16px;\r\n\r\n        &:hover {\r\n          transform: translateY(-6px);\r\n        }\r\n\r\n        .widget-header {\r\n          padding: 1.5rem 1.5rem 1rem;\r\n\r\n          h3 {\r\n            font-size: 1.2rem;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    .member-selection {\r\n      flex-direction: column;\r\n      align-items: flex-start;\r\n      gap: 0.5rem;\r\n      width: 100%;\r\n      \r\n      .member-dropdown {\r\n        min-width: 100%;\r\n        padding: 10px 12px;\r\n        padding-right: 36px;\r\n        font-size: 0.95rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  @media (max-width: 480px) {\r\n    padding: 0.75rem;\r\n\r\n    .dashboard-header h1 {\r\n      font-size: 1.75rem;\r\n    }\r\n\r\n    .member-selection {\r\n      flex-direction: column;\r\n      align-items: flex-start;\r\n      gap: 0.5rem;\r\n      width: 100%;\r\n\r\n      label {\r\n        font-size: 0.85rem;\r\n      }\r\n      \r\n      .member-dropdown {\r\n        min-width: 100%;\r\n        padding: 8px 10px;\r\n        padding-right: 32px;\r\n        font-size: 0.9rem;\r\n      }\r\n    }\r\n\r\n    .widgets-grid .widget {\r\n      border-radius: 12px;\r\n\r\n      .widget-header {\r\n        padding: 1.25rem 1.25rem 0.75rem;\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
